import { useEffect, useState } from 'react'

import { Box, Grid, Title } from '@factorialco/deprecated-design-system'
import {
  IntegrationsJoinCompanyIntegrationsDocument,
  JoinExternalIntegrationFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { ExternalProfilesItem } from './ExternalProfilesItem'

export const ExternalProfiles = () => {
  const { access, company } = useCurrentSession()
  const [integrationsList, setIntegrationList] = useState<JoinExternalIntegrationFragment[]>([])
  const [fetchCompanyIntegrations] = useMutation(IntegrationsJoinCompanyIntegrationsDocument, {
    extractorFn: (response) => response.integrationsJoinMutations.listIntegrationsjoinIntegration,
  })

  const fetchIntegrationsList = async () => {
    const result = await fetchCompanyIntegrations({
      variables: { accessId: access?.id, companyId: company?.id },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      setIntegrationList(handled.data?.integrations || [])
    } else {
      // hack: we don't whant to show an error message
      // we should have a param to avoid this
      app.setFlash({
        type: 'wrong',
        message: '',
        time: 0,
      })
    }
  }

  useEffect(() => {
    fetchIntegrationsList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access, company])

  if (integrationsList.length === 0) return null

  return (
    <Box paddingX="s64" paddingBottom="s32" width="full" gap="s24">
      <Title title={i18n.t('ats.settings.job_promotions.external_profiles.title')} variant="500" />

      <Grid variant="medium">
        {integrationsList.map((integration) => (
          <ExternalProfilesItem
            key={integration.slug}
            integrationProfile={integration}
            onUpdate={fetchIntegrationsList}
          />
        ))}
      </Grid>
    </Box>
  )
}
